import Section from './_Section'
import { createMarkup } from '../../helpers/markup'
import ButtonEl from '../helpers/ctas/Button'
import { ArrowRightIcon, PhoneIcon } from '@heroicons/react/24/solid'
import TitleBlock from '../helpers/TitleBlock'
import { transformPaddingToTailwind } from '../../helpers/style'

function CalloutCard(props) {
  const sectionGradient = !['None', 'ContentArea'].includes(props.backgroundGradientType)
  const contentGradient = ['ContentArea'].includes(props.backgroundGradientType)
  const componentPadding = transformPaddingToTailwind(props.componentPadding)

  return (
    <Section
      type="calloutCard"
      outerClass={componentPadding}
      sectionTitle={false}
      innerClass="flex justify-center"
      {...props}
    >
      <div className="flex max-lg:flex-col justify-center items-center max-lg:text-center mx-6 gap-6 w-full">
        {(props.title || props.description) && (
          <TitleBlock headingClass={`w-full ${props.ctaLink.length != 0 ? 'max-w-md' : ''}`} {...props} />
        )}
        {props.ctaLink.length != 0 && (
          <div className="flex max-lg:flex-col items-center gap-6">
            {props.ctaLink.map((ctaLinkItem, i) => {
              let content = ctaLinkItem.link?.name
              const url = ctaLinkItem.link?.url
              if (content) {
                if (url?.startsWith('tel:')) {
                  content = (
                    <>
                      <PhoneIcon role="none" className="h-6 w-6 mr-2" />
                      {content}
                    </>
                  )
                } else {
                  content = (
                    <>
                      {content}
                      <ArrowRightIcon role="none" className="h-6 w-6 ml-2" />
                    </>
                  )
                }
              }
              return (
                <div key={i} className={url?.startsWith('tel:') ? 'tel' : undefined}>
                  <ButtonEl
                    link={ctaLinkItem.link}
                    theme={ctaLinkItem.linkType.toLowerCase()}
                    icon={ctaLinkItem.linkIconClass}
                  >
                    {content}
                  </ButtonEl>
                </div>
              )
            })}
          </div>
        )}
      </div>
    </Section>
  )
}

export default CalloutCard
